module.exports = __webpack_public_path__ + "static/media/github.e4a93dac.svg";